// Special implementation of KeyTechs for Vikings

import classNames from 'classnames'
import colors from '../../config/colors.json'
import rgbHex from 'rgb-hex'

function numberToAngle(current, max) {
	if (!max) return 0 // prevent divide by zero
	return 360 * (current / max)
}

export function LiveGameKeyTechTimer({ tech, currentUpgrades, color, current = 0, cooldownDuration = 0, maxTechs = 3, icon, improved = false }) {
	const upgrades = Object.values(currentUpgrades || [])?.filter((upgrade) => tech.requiredUpgrades?.includes(parseInt(upgrade)))
	const hasImproved = Object.values(currentUpgrades || [])?.filter((upgrade) => improved === parseInt(upgrade))

	if (!color) return
	let mainColor = rgbHex(colors[color]?.mainColor) || 'white'
	let alpha = colors[color]?.mainColorAlpha5
	let alphaColor = alpha ? `#${rgbHex(alpha)}` : 'white'

	let rounded = maxTechs === 6 ? 'mx-[0.5px] rounded-sm liveGameOverlay__macedonianKeyTechDot' : 'mx-[1px] rounded-lg'

	let angle = numberToAngle(current, cooldownDuration)

	return (
		<div className={classNames('w-[40px] h-[53px] flex flex-col mx-[2px]')}>
			<div className="w-[40px] h-[40px] relative" style={{ '--angle': `${angle}deg` }}>
				<div
					className="w-[40px] h-[40px] absolute"
					style={{
						backgroundImage: `url(/liveGameIcons/tech_background.png)`,
					}}>
					<img className="w-10 h-10" src={icon} alt="" />
				</div>
				<div className={classNames('h-[40px] w-[40px] mask-clock')} style={{ '--angle': `${angle}deg`, backgroundColor: alphaColor }}></div>
			</div>
			<div className="mt-[2px] flex flex-row justify-center">
				{/* For the length of required upgrades make a dot stroke-[#5E6989]*/}
				{Array.from({ length: maxTechs || 0 }).map((_, index) => (
					<div
						key={index}
						className={classNames(rounded, `outline-[#5E6989] outline-[0.5px] w-9 h-[9px] z-10`)}
						style={{
							outlineStyle: 'solid',
							backgroundColor: upgrades[index] ? `#${mainColor}` : '#2E2E2E',
						}}></div>
				))}
			</div>
			{improved && (
				<div className="absolute flex flex-row justify-center mt-9 mx-auto w-10">
					<div
						key={'improvedMongols'}
						className={classNames(rounded, `outline-[#5E6989] outline-[0.5px] w-8 h-[7px]`)}
						style={{
							outlineStyle: 'solid',
							backgroundColor: hasImproved[0] ? `#${mainColor}` : '#2E2E2E',
						}}></div>
				</div>
			)}
		</div>
	)
}
